import { useTranslation } from 'react-i18next';
import { Pill } from '@components/ui/Pill/Pill';
import { WrenchIcon } from '@utils/icons';
import styles from './MaintenanceFlag.module.css';

export function MaintenanceFlag() {
  const { t } = useTranslation();
  return (
    <Pill className={styles.flag}>
      <WrenchIcon size={9} />
      {t('equipment.needsMaintenance')}
    </Pill>
  );
}
